import request from 'utils/request';

let userService = {
    login:function(data){
        return request('/login',{
            method:'POST',
            data,
            headers: { "Content-Type": "application/json;charset=UTF-8" },
        })
    }
};


export default userService;